import React, { forwardRef } from "react";
import Text from "../text/Text";
const headingTitleFactory = (defaultVariant, as) => 
// support all TextProps for now. Switch to HeadingTitleProps<V> in future to be more restrictive
forwardRef(function HeadingTitle(props, ref) {
    return React.createElement(Text, Object.assign({ ref: ref, as: as, variant: defaultVariant }, props));
});
export const H1 = headingTitleFactory("heading1", "h1");
export const H2 = headingTitleFactory("heading2", "h2");
export const H3 = headingTitleFactory("heading3", "h3");
export const H4 = headingTitleFactory("heading4", "h4");
export const H5 = headingTitleFactory("heading5", "h5");
export const H6 = headingTitleFactory("heading6", "h6");
//# sourceMappingURL=HeadingTitles.js.map